import { ReactNode } from 'react';
import { View } from 'react-native';
import { Label } from '@/common/components/Label/Label';
import {
  ILabeledValueHorizontalProps,
  LabeledValue,
} from '@/common/components/LabeledValue/LabeledValue';
import { Stack } from '@/common/components/Stack/Stack';

function LabeledValueListRoot({
  title,
  children,
  className,
  solid,
  rowGap = 'sm',
}: TLabeledValueListProps) {
  return (
    <Stack gap="md" className={className}>
      {title && (
        <Stack horizontal justify="between" align="start">
          <Label bold color="neutral20" size="sm">
            {title}
          </Label>
          {solid && <View className={styles.dash} />}
        </Stack>
      )}
      <Stack gap={rowGap}>{children}</Stack>
    </Stack>
  );
}

function LabeledValueListItem(props: TLabeledValueListItemProps) {
  return <LabeledValue orientation="horizontal" {...props} />;
}

export const LabeledValueList = {
  Root: LabeledValueListRoot,
  Item: LabeledValueListItem,
};

const styles = {
  dash: 'mx-sm min-w-[0.3rem] flex-1 border-b-[0.1rem] border-solid border-b-neutral20 pt-[1rem]',
};

export type TLabeledValueListItemProps = Omit<
  ILabeledValueHorizontalProps,
  'orientation'
>;

export type TLabeledValueListProps = {
  title: ReactNode;
  children: ReactNode;
  className?: string;
  solid?: boolean;
  rowGap?: 'xs' | 'sm';
};
